module.exports = __webpack_public_path__ + "static/media/chat.110c024b.svg";